define('ShippingByLocation.Repository', [], function ShippingByLocationRepositoryModule() {
  'use strict';

  function getKeyForCurrentProduct(container) {
    var pdp = container.getComponent('PDP');
    var productId = pdp.getItemInfo().item.internalid;
    return productId ? String(productId) : null;
  }

  function getNewInstance(container, ShippingByLocation) {
    return new ShippingByLocation({ container: container });
  }

  return {
    repository: {},

    getForCurrentProduct: function getForCurrentProduct(container, ShippingByLocation) {
      var key = getKeyForCurrentProduct(container);
      if (!key) {
        return getNewInstance(container, ShippingByLocation);
      }
      if (!this.repository[key]) {
        this.repository[key] = getNewInstance(container, ShippingByLocation);
      }
      return this.repository[key];
    },

    setupForCurrentProduct: function setupForCurrentProduct(container, ShippingByLocation) {
      var key = getKeyForCurrentProduct(container);
      if (!key) {
        return;
      }
      if (this.repository[key]) {
        return;
      }
      this.repository[key] = getNewInstance(container, ShippingByLocation);
    }
  };
});
